import { HIDE_PLAYER_ERROR, SHOW_PLAYER_ERROR } from 'containers/Player/actions/errors/constants';

export const showPlayerError = error => ({
  type: SHOW_PLAYER_ERROR,
  error,
});

export const hidePlayerError = () => ({
  type: HIDE_PLAYER_ERROR,
});
